import React from "react";
import styled from "styled-components";
import { Divider } from "semantic-ui-react";

import {
  DoubleInputGrid,
  GeneralContainer,
  FlexDiv,
  Value,
  QuestionTitle,
} from "../../shared";

interface Props {
  additionalInfo: { [key: string]: any };
}

const EpaMethodsPart2: React.FC<Props> = ({ additionalInfo }) => {
  const {
    inventoryMethodsPart2Q1ServiceLineMaterialIdentificationChoices,
    inventoryMethodsPart2Q1ServiceLineMaterialIdentificationOtherExplanation,
    inventoryMethodsPart2Q2StandardProceduresYesNo,
    inventoryMethodsPart2Q2StandardProceduresOtherExplanation,
  } = additionalInfo;

  const hasWaterMeterReading =
    inventoryMethodsPart2Q1ServiceLineMaterialIdentificationChoices?.includes(
      "Water meter reading"
    );
  const hasWaterMeterRepairOrReplacement =
    inventoryMethodsPart2Q1ServiceLineMaterialIdentificationChoices?.includes(
      "Water meter repair or replacement"
    );
  const hasServiceLineRepairOrReplacement =
    inventoryMethodsPart2Q1ServiceLineMaterialIdentificationChoices?.includes(
      "Service line repair or replacement"
    );
  const hasWaterMainRepairOrReplacement =
    inventoryMethodsPart2Q1ServiceLineMaterialIdentificationChoices?.includes(
      "Water main repair or replacement"
    );
  const hasBackflowPreventionDevice =
    inventoryMethodsPart2Q1ServiceLineMaterialIdentificationChoices?.includes(
      "Backflow prevention device inspection"
    );
  const hasOther =
    inventoryMethodsPart2Q1ServiceLineMaterialIdentificationChoices?.includes(
      "Other"
    );

  return (
    <GeneralContainer>
      <div>
        <p style={{ marginBottom: "0px" }}>
          During which normal operating activities are you collecting
          information on service line material? Check all that apply.
        </p>
        <DoubleInputGrid>
          <StyledFlexDiv>
            <input type="checkbox" id="waterMeterReading" checked={hasWaterMeterReading} />
            <label htmlFor="waterMeterReading">Water meter reading</label>
          </StyledFlexDiv>
          <StyledFlexDiv>
            <input type="checkbox" id="waterMeterRepairOrReplacement" checked={hasWaterMeterRepairOrReplacement} />
            <label htmlFor="waterMeterRepairOrReplacement">Water meter repair or replacement</label>
          </StyledFlexDiv>
          <StyledFlexDiv>
            <input
              type="checkbox"
              id="serviceLineRepairOrReplacement"
              checked={hasServiceLineRepairOrReplacement}
            />
            <label htmlFor="serviceLineRepairOrReplacement">Service line repair or replacement</label>
          </StyledFlexDiv>
          <StyledFlexDiv>
            <input type="checkbox" id="waterMainRepairOrReplacement" checked={hasWaterMainRepairOrReplacement} />
            <label htmlFor="waterMainRepairOrReplacement">Water main repair or replacement</label>
          </StyledFlexDiv>
          <StyledFlexDiv>
            <input type="checkbox" id="backflowPreventionDevice" checked={hasBackflowPreventionDevice} />
            <label htmlFor="backflowPreventionDevice">Backflow prevention device inspection</label>
          </StyledFlexDiv>
          <StyledFlexDiv>
            <input type="checkbox" id="other" checked={hasOther} />
            <label htmlFor="other">Other</label>
          </StyledFlexDiv>
        </DoubleInputGrid>
      </div>
      <Divider />
      <div>
        <QuestionTitle>If other please explain</QuestionTitle>
        <Value>
          {inventoryMethodsPart2Q1ServiceLineMaterialIdentificationOtherExplanation ??
            "--"}
        </Value>
      </div>
      <Divider />
      <div>
        <QuestionTitle>
          Did you develop or revise standard operating procedures to collect
          service line material information during normal operation?
        </QuestionTitle>
        <Value>{inventoryMethodsPart2Q2StandardProceduresYesNo ?? "--"}</Value>
      </div>
      <div>
        <QuestionTitle>If Yes, please describe</QuestionTitle>
        <Value>
          {inventoryMethodsPart2Q2StandardProceduresOtherExplanation ?? "--"}
        </Value>
      </div>
      <Divider />
    </GeneralContainer>
  );
};

const StyledFlexDiv = styled(FlexDiv)`
  pointer-events: none;
`;

export default EpaMethodsPart2;
